<template>
  <div class="root">
    <div class="container" :class="{ 'iOS-container-safe-bottom': isIPhone(), 'container-margin-top': isMobile }" id="main" v-if="isOffline === false">
      <section v-if="checkPanel('home')">
        <home/>
      </section>

      <section v-if="checkPanel('horoscope')">
        <horoscope/>
      </section>

      <section v-if="checkPanel('horoscope-sign')">
        <horoscope-show :sign="this.sign"/>
      </section>

      <section v-if="checkPanel('moon-category-info')">
        <moon-prediction-show :category="this.moonCategory"/>
      </section>

      <section v-if="checkPanel('origin')">
        <origin/>
      </section>
    </div>
    <div class="container" :class="{ 'container-margin-top': isMobile }" id="offline" v-if="isOffline === true">
      <div @click="checkOffline" class="white-wrapper text-center">
        <svg height="28px" style="cursor: default" version="1.1" viewBox="0 0 28 28" width="28px"
             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
            <g id="cancel_outline_28">
              <rect height="28" width="28" x="0" y="0"></rect>
              <path
                  id="↳-Icon-Color"
                  d="M6.29289322,6.29289322 C6.68341751,5.90236893 7.31658249,5.90236893 7.70710678,6.29289322 L7.70710678,6.29289322 L14,12.585 L20.2928932,6.29289322 C20.6533772,5.93240926 21.2206082,5.90467972 21.6128994,6.20970461 L21.7071068,6.29289322 C22.0976311,6.68341751 22.0976311,7.31658249 21.7071068,7.70710678 L21.7071068,7.70710678 L15.415,14 L21.7071068,20.2928932 C22.0675907,20.6533772 22.0953203,21.2206082 21.7902954,21.6128994 L21.7071068,21.7071068 C21.3165825,22.0976311 20.6834175,22.0976311 20.2928932,21.7071068 L20.2928932,21.7071068 L14,15.415 L7.70710678,21.7071068 C7.34662282,22.0675907 6.77939176,22.0953203 6.38710056,21.7902954 L6.29289322,21.7071068 C5.90236893,21.3165825 5.90236893,20.6834175 6.29289322,20.2928932 L6.29289322,20.2928932 L12.585,14 L6.29289322,7.70710678 C5.93240926,7.34662282 5.90467972,6.77939176 6.20970461,6.38710056 Z"
                  fill="currentColor" fill-rule="nonzero"></path>
            </g>
          </g>
        </svg>
        <p>Что-то пошло не так. Возможно, была потеряна связь с Интернетом...</p>
        <span class="btn btn-default">Обновить</span>
      </div>
    </div>
  </div>
</template>

<script>
import bridge from '@vkontakte/vk-bridge';
import {store} from "@/store";
import {offline} from "./mixins/Offline";
import client from "@/services/client";
import {heightIFrame, isIPhone, prepareLaunchParams, setTheme, updateHistory} from "./lib/utils";
import {managePanels, manageScrollPosition} from "@/lib/navigation";

import Home from "@/layout/screens/Home";
import Horoscope from "@/layout/screens/Horoscope";
import Origin from "@/layout/screens/Origin";
import MoonPredictionShow from "@/layout/screens/MoonPrediction";
import HoroscopeShow from "@/layout/screens/HoroscopeShow";

export default {
  name: "App",
  mixins: [offline],
  store,
  components: {HoroscopeShow, MoonPredictionShow, Origin, Horoscope, Home},
  data() {
    return {
      sign: "",
      moonCategory: null,
    }
  },
  created() {
    prepareLaunchParams(store);
    setTheme();
  },
  mounted() {
    bridge.send("VKWebAppInit", {});
    heightIFrame();
    this.$nextTick(() => {
      heightIFrame();
    })

    // Обработка аппаратной клавиши "назад"
    window.onpopstate = (e) => {
      managePanels(this, e);
    };

    this.$root.$on('showHoroscope', () => {
      this.showHoroscope();
    });

    this.$root.$on('showHoroscopeSign', (sign) => {
      this.sign = sign;
      this.showHoroscopeSign();
    });

    this.$root.$on('showMoonCategoryInfo', (category) => {
      this.moonCategory = category;
      this.showMoonCategoryInfo();
    });

    this.$root.$on('showOrigin', () => {
      this.showOrigin();
    });
  },
  updated() {
    if (store.state.lastActivePanel !== "") {
      let root = document.querySelector(".root");
      let shadow = document.createElement("div");
      shadow.classList.add("shadow-bg");
      root.appendChild(shadow)

      setTimeout(() => {
        manageScrollPosition(store, "load");
        root.removeChild(shadow);

        heightIFrame();
      }, 0);
    }

    this.$nextTick(() => {
      heightIFrame();
    })
  },
  methods: {
    checkPanel(panel) {
      return store.state.activePanel === panel;
    },

    showOrigin() {
      updateHistory("origin", this);
      manageScrollPosition(this.$store, 'save');

      this.$store.commit('setLastActivePanel', 'home');
      this.$store.commit('setActivePanel', 'origin');
    },

    showHoroscope() {
      updateHistory("horoscope", this);
      manageScrollPosition(store, 'save');

      store.commit('setLastActivePanel', 'home');
      store.commit('setActivePanel', 'horoscope');
    },

    showMoonCategoryInfo() {
      updateHistory("category-info", this);
      manageScrollPosition(store, 'save');

      store.commit('setLastActivePanel', 'home');
      store.commit('setActivePanel', 'moon-category-info');
    },

    showHoroscopeSign() {
      updateHistory("horoscope-sign", this);
      manageScrollPosition(store, 'save');

      store.commit('setLastActivePanel', 'horoscope');
      store.commit('setActivePanel', 'horoscope-sign');
    },

    isIPhone() {
      return isIPhone(store);
    },
  },
  computed: {
    isMobile() {
      return client.isMobile();
    },
  }
};
</script>

<style lang="scss">
@import "./scss/app";

section {
  padding-bottom: 28px;
}

.shadow-bg {
  width: 100%;
  height: 100%;
  background-color: var(--background-color);
  position: absolute;
  z-index: 999;
}
</style>
